module.exports = __webpack_public_path__ + "img/collection-engagementRings@2x.7f99c73.webp";